<template>
    <v-row justify="center">
        <v-dialog
            class="department-modal"
            v-model="dialog"
            persistent
            max-width="370">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ headerText }}
                    </v-card-title>
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation>
                        <v-text-field
                            label="Device Name"
                            v-model="form.name"
                            placeholder=" "
                            autocomplete="off"
                            :error-messages="errors.name"
                            :rules="inputRules">
                        </v-text-field>
                        <v-text-field v-if="!isZktGateway"
                            label="Serial Number"
                            v-model="form.serial_number"
                            placeholder=" "
                            autocomplete="off"
                            :error-messages="errors.serial_number"
                            :rules="inputRules">
                        </v-text-field>
                        <v-text-field v-if="!isZktGateway"
                            label="Endpoint"
                            v-model="form.endpoint"
                            placeholder=" "
                            autocomplete="off"
                            :error-messages="errors.endpoint"
                            :rules="inputRules">
                        </v-text-field>
                        <v-text-field v-if="isZktGateway"
                            label="Group Code"
                            v-model="form.group_code"
                            placeholder=" "
                            autocomplete="off"
                            :error-messages="errors.group_code"
                            :rules="inputRules">
                        </v-text-field>
                        <v-text-field v-if="isZktGateway"
                            label="Access Key"
                            v-model="form.access_key"
                            placeholder=" "
                            autocomplete="off"
                            :error-messages="errors.access_key"
                            :rules="inputRules">
                        </v-text-field>
                        <v-autocomplete
                            label="Branch"
                            v-model="form.branch_id"
                            :key="form.branch_id"
                            :items="$store.state.branches"
                            :rules="inputRules"
                            item-text="name"
                            item-value="id">
                        </v-autocomplete>
                        <v-checkbox
                            v-model="form.can_upload"
                            label="Can upload image to device"
                        />
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitForm()">
                        Save
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            default: null
        },

        updateDeviceId: {
            type: Number,
            default: null
        },

        isZktGateway: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            dialog: false,
            valid: true,
            form: {
                name: '',
                serial_number: '',
                branch_id: '',
                endpoint: '',
                group_code: '',
                access_key: '',
                can_upload: false
            },
            inputRules: [
                v => !!v || 'this field is required',
                v => (v && v.toString().trim().length > 0) || 'this field is required'
            ],
            errors: [],
            deviceId: '',
            headerText: ''
        }
    },

    methods: {
        closeModal () {
            this.clearForm()
            this.$refs.form.resetValidation()
            this.$emit('close-modal')
            this.dialog = false
        },

        clearForm () {
            this.form = {
                name: '',
                serial_number: '',
                branch_id: '',
                endpoint: '',
                group_code: '',
                access_key: '',
                can_upload: false
            }
            this.errors = []
        },

        submitForm () {
            if (!this.$refs.form.validate()) {
                return
            }
            if (this.mode === 'create') {
                this.createDevice()
            } else if (this.mode === 'update') {
                this.updateDevice()
            }
        },

        async createDevice () {
            this.$store.dispatch('setLoading', true)

            this.removeKeyForm()

            const res = await this.axios.post('device/create', this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-created')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: 'Congratulation',
                    text: 'Device is created.',
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: 'Error message',
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async updateDevice () {
            this.$store.dispatch('setLoading', true)

            this.removeKeyForm()

            const url = `device/edit/${this.updateDeviceId}`
            const res = await this.axios.put(url, this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-updated')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: 'Congratulation',
                    text: 'Device is updated.',
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: 'Error message',
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        removeKeyForm () {
            if (this.isZktGateway) {
                // zkt
                delete this.form.serial_number
                delete this.form.endpoint
            } else {
                // dmp
                delete this.form.group_code
                delete this.form.access_key
            }

            delete this.form.finger_amount
            delete this.form.emp_amount
        },

        async getDevice (deviceId) {
            this.$store.dispatch('setLoading', true)
            const url = `device/${deviceId}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                const data = res.data.data
                this.form = {
                    name: data.name,
                    serial_number: data.serial_number,
                    branch_id: data.branch,
                    endpoint: data.endpoint,
                    group_code: data.group_code,
                    access_key: data.access_key,
                    can_upload: data.can_upload
                }
            }
        }

    },

    watch: {
        async mode (newValue, oldValue) {
            if (newValue === 'create') {
                this.clearForm()
                this.headerText = 'Create New Device'
            } else if (newValue === 'update') {
                this.headerText = 'Update Device'
                this.getDevice(this.updateDeviceId)
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
